var map = {
	"./pratique1.jpg": 8078,
	"./pratique2.jpg": 8345,
	"./presidente.jpg": 5035,
	"app/images/navigation/pratique1.jpg": 8078,
	"app/images/navigation/pratique2.jpg": 8345,
	"app/images/navigation/presidente.jpg": 5035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3740;